import { requireComponent } from '@/utils'
import Layout from '@/layout/index.vue'
const dir = process.env.NODE_ENV === 'development' ? '/VOD' : ''
const VODRouter = [
  {
    path: '/',
    redirect: `${dir}/dataAnalysis`,
    component: Layout,
    name: 'Layout',
    children: [
      {
        path: dir + '/dataAnalysis',
        component: requireComponent('VOD/data-analysis'),
        name: 'dataAnalysis',
        meta: {
          title: '概览' + dir,
          icon: 'icon-shuju-on'
        }
      },
      {
        path: dir + '/programManagement',
        component: requireComponent('VOD/program-management'),
        name: 'programManagement',
        meta: {
          title: '节目管理' + dir,
          icon: 'icon-jiemu-on'
        }
      },
      {
        path: dir + '/programGroupManagement',
        name: 'programGroupManagement',
        meta: {
          title: '节目集管理' + dir,
          icon: 'icon-jiemugaikuang'
        },
        component: requireComponent('VOD/program-group-management')
      },
      {
        path: '/newGroup',
        name: 'newGroup',
        meta: {
          title: '节目编目',
          hidden: true
        },
        component: requireComponent('common/program-group.vue')
      },
      {
        path: '/managementGroup',
        name: 'managementGroup',
        meta: {
          title: '节目集管理',
          hidden: true,
          breadCrumb: true
        },
        component: requireComponent('VOD/program-group-management/management-group.vue')
      },
      {
        path: '/createGroup',
        name: 'createGroup',
        meta: {
          title: '新建节目集',
          hidden: true,
          breadCrumb: true
        },
        component: requireComponent('common/add-program-group.vue')
      },
      {
        path: '/editGroup',
        name: 'editGroup',
        meta: {
          title: '编辑节目集',
          hidden: true,
          breadCrumb: true
        },
        component: requireComponent('common/add-program-group.vue')
      },
      {
        path: dir + '/auditManagement',
        name: 'auditManagement',
        meta: {
          title: '审核管理' + dir,
          icon: 'icon-shenheguanli'
        },
        component: requireComponent('VOD/audit-management')
      },
      {
        path: dir + '/releaseManagement',
        component: requireComponent('VOD/release-management'),
        name: 'releaseManagement',
        meta: {
          title: '发布管理' + dir,
          icon: 'icon-fabu'
        }
      },
      {
        path: dir + '/transCoding',
        component: requireComponent('VOD/trans-coding'),
        name: 'transCoding',
        meta: {
          title: '通用设置' + dir,
          icon: 'icon-shezhi'
        }
      },
      {
        path: '/upload',
        name: 'uploadVideo',
        meta: {
          title: '上传',
          hidden: true
        },
        component: requireComponent('common/upload-video.vue')
      },
      {
        path: '/uploadFile',
        name: 'uploadVideo',
        meta: {
          title: '上传',
          hidden: true
        },
        component: requireComponent('common/upload-file.vue')
      }
    ]
  }
]
export default VODRouter
